import React from "react";

import { Grid, Card, Typography } from "@material-ui/core";
import "../CardGenericoSearch/styles.css";
import { formatPrice } from "../../../utils/functions";

export default function CardSemEnderecamento({ iten }) {

  const prob = iten.problema_enderecamento;
  const qtdRJ = (prob === 'RJ' || prob === 'RJ e SP') ? (iten.CD_RJ || 0) : 0;
  const qtdSP = (prob === 'SP' || prob === 'RJ e SP') ? (iten.CD_SP || 0) : 0;
  const receita = (qtdRJ + qtdSP) * (iten.PRECO_ECOMMERCE || 0);

  let qtdeRj = 0;
  let qtdeSp = 0;

  if (iten.LOCALIZACAO_ENDERECADO && Array.isArray(iten.LOCALIZACAO_ENDERECADO)) {
    iten.LOCALIZACAO_ENDERECADO.forEach(loc => {
      if (loc.DEPOSITO_ENDERECADO && loc.DEPOSITO_ENDERECADO.includes('RJ')) {
        qtdeRj += loc.QTDE_DISPONIVEL || 0;
      }
      if (loc.DEPOSITO_ENDERECADO && loc.DEPOSITO_ENDERECADO.includes('SP')) {
        qtdeSp += loc.QTDE_DISPONIVEL || 0;
      }
    });
  }

  return (
    <>
      <Grid direction="row" item xs={12} sm={6} value={iten.REF} id={`elemento_${iten.REF}`}>
        <Card className="root-card2" variant="outlined">

          <Grid container direction="row" spacing={1} >
            <div className="tamanho-card">
              <div className="topo-card-generico">
                <div >
                  <p className="title-card-2">Referência</p>
                  <p className="value-1">{iten.REF}</p>
                </div>
              </div>

              <div className="white-space-3"></div>

              <div className="box-skus-1">
                <div className="box-skus-2">
                  <p className="title-2">Qtd. de Skus:</p>
                  <p className="m-l-5 value-1">{iten.qtd_skus}</p>
                </div>

                <div className="box-skus-2">
                  <p className="title-2">Estoque Total:</p>
                  <p className="m-l-5 value-1">{iten.ESTOQUE}</p>
                </div>

                <div className="box-skus-2">
                  <p className="title-2">Estoque CD RJ/SP:</p>
                  <p className="m-l-5 value-1">{iten.CD_RJ || 0} / {iten.CD_SP || 0}</p>
                </div>

                <div className="box-skus-2">
                  <p className="title-2">Endereçados RJ/SP:</p>
                  <p className="m-l-5 value-1">{qtdeRj} / {qtdeSp}</p>
                </div>

                <div className="box-skus-2">
                  <p className="title-2">Receita:</p>
                  <p style={{ width: "100%" }} className="m-l-5 value-1">{formatPrice(receita)}</p>
                </div>

              </div>
            </div>
          </Grid>

        </Card>
      </Grid>
    </>
  );
}
